import { useEffect, useRef } from 'react'

/**
 * @desc  visibilitychange 이벤트를 관리하는 Hook
 *
 * @param {boolean} isActive  해당 훅에서 로직 실행 여부.
 * @param {function} onVisible  visible 상태일 때 실행될 콜백 함수.
 *
 * */
const useVisibilityChange = ({ isActive = true, onVisible }) => {
  const onVisibleRef = useRef(onVisible)

  useEffect(() => {
    onVisibleRef.current = onVisible
  }, [onVisible])

  useEffect(() => {
    if (!isActive) return

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        onVisibleRef.current()
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [isActive])
}

export default useVisibilityChange
